import { Injectable, inject } from '@angular/core';
import { companyApiActions } from '@mkp/company/state/actions';
import { ActionState } from '@mkp/shared/models';
import { SnackbarService } from '@mkp/shared/util-snackbar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

@Injectable()
export class CompanyNotificationEffects {
  private readonly actions$ = inject(Actions);
  private readonly notificationService = inject(SnackbarService);

  readonly showUpdateCompanySuccessNotification$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(companyApiActions.updateCompanySuccess),
        tap(() => this.notificationService.show('COMPANY_PAGE.PROFILE.MESSAGE.UPDATE'))
      );
    },
    { dispatch: false }
  );

  readonly showUpdateCompanyNoChangesNotification$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(companyApiActions.updateCompanyNoChanges),
        tap(() => this.notificationService.show('GENERIC.SNACKBAR.NO_CHANGES_MESSAGE'))
      );
    },
    { dispatch: false }
  );

  readonly showUpdateCompanyFailureNotification$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(companyApiActions.updateCompanyFailure),
        tap(() =>
          this.notificationService.show('COMPANY_PAGE.PROFILE.MESSAGE.UPDATE_FAILED', {
            state: ActionState.Error,
          })
        )
      );
    },
    { dispatch: false }
  );
}
